<template>
  <div>
    <div v-if="accept.indexOf('image') != -1" style="display:flex">
      <template>
        <div
          v-if="model"
          class="demo-upload-list"
          v-for="(item, index) in model.files"
        >
          <template>
            <img :src="getPath(item)" />
            <div class="demo-upload-list-cover">
              <Icon
                type="ios-eye-outline"
                @click.native="handleView(item)"
              ></Icon>
              <Icon
                type="ios-trash-outline"
                @click.native="onTagClose(index)"
              ></Icon>
            </div>
          </template>
        </div>
        <Upload
          ref="uploadImage"
          :show-upload-list="false"
          :max-size="maxSize"
          :on-format-error="uploadFileError"
          :on-exceeded-size="fileMaxSize"
          :before-upload="beforeUpload"
          :multiple="true"
          :accept="accept"
          v-if="!hide"
          action
          style="
          width: 100px;
          height: 135px;
          vertical-align: center;
        "
        >
          <Button
            type="dashed"
            size="large"
            :style="{ width: '100px', height: '135px' }"
          >
            <Icon
              type="ios-camera"
              size="40"
            ></Icon>
          </Button>
        </Upload>

        <Modal
          v-model="showImage"
          footer-hide
        >
          <img
            :src="getPath(selectFile)"
            v-if="showImage"
            style="width: 100%"
          />
        </Modal>
      </template>
    </div>

    <template v-else>
      <Upload
        ref="upload"
        :show-upload-list="false"
        :max-size="maxSize"
        :on-format-error="uploadFileError"
        :on-exceeded-size="fileMaxSize"
        :before-upload="beforeUpload"
        :multiple="true"
        :accept="accept"
        v-if="!hide"
        action
      >
        <Button icon="ios-cloud-upload-outline">上传文件</Button>
      </Upload>
      <div v-if="model && accept.indexOf('image') == -1">
        <Card
          v-if="model.files.length != 0"
          :style="
            'margin-top:10px;' +
            'width:' +
            width +
            'px;' +
            'min-height:' +
            height +
            'px'
          "
        >
          <Tag
            size="medium"
            v-for="(item, index) in model.files"
            :key="index"
            :closable="!hide"
            @on-close="onTagClose(index)"
          ><span @click="open(item)">{{ getFileName(item) }}</span></Tag>
        </Card>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: "YnUpload",
  props: {
    value: {
      type: [Object, String, Array, Number, Function, Promise],
      default() {
        return { filesCount: 0, id: null, files: [] };
      },
      // get: function() {
      //   console.log("设置value")
      //   let files = this.value.files.map((x) => {
      //     return {
      //       no: x.o.no,
      //       name: x.o.name,
      //       path: x.o.path,
      //       fullPath: x.o.fullPath,
      //     };
      //   });

      //   var info = {
      //     filesCount: this.value.files.length,
      //     id: this.value.id,
      //     files: files,
      //   };
      //   console.log("valueSet:" + JSON.stringify(info))
      //   return info;
      // }
    },
    hide: {
      type: Boolean,
      default: false,
    },
    config: {
      type: String,
      default: null,
    },
    max: {
      type: Number,
      default: 0,
    },
    accept: {
      type: String,
      default: "file",
    },
    maxSize: {
      type: Number,
      default: 50 * 1024 * 1024,
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 150,
    },
  },
  computed: {
    model: {
      get: function () {
        // let files = this.value.files.map((x) => {
        //   return {
        //     no: x.o.no,
        //     name: x.o.name,
        //     path: x.o.path,
        //     fullPath: x.o.fullPath,
        //   };
        // });

        // var info = {
        //   filesCount: this.value.files.length,
        //   id: this.value.id,
        //   files: files,
        // };
        // console.log("get:" + JSON.stringify(info))
        // return info;
        return this.value;
      },
      set: function (value) {
        console.log("set:" + JSON.stringify(value));
        return this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      uploadFile: null,
      deleteFiles: [],
      showImage: false,
      selectFile: null,
    };
  },
  methods: {
    onTagClose(index) {
      // var array = Object.assign({},this.model);
      let deleteData = this.model.files.splice(index, 1)[0];
      console.log(JSON.stringify(this.model));
      if (deleteData.file == undefined) {
        //不是本地图片的话,加入到删除的数组
        this.deleteFiles.push({ on: deleteData.o.no, path: deleteData.o.path });
      }
      // this.model = array;
    },
    ///文件预览
    open(item){
     if(item!=null&&item.o!=undefined&&item.o.fullPath!=""){
        window.open(item.o.fullPath,"_blank");
     }else{
       this.$Message.warning(`无数据`);
     }
    },
    getPath(file) {
      if (file.base64 != undefined && file.base64.length > 0) {
        return file.base64;
      }

      return file.o.fullPath;
    },
    getFileName(file) {
      if (file.o != undefined && file.o.length > 0) {
        return file.o.name;
      }
      return file.name;
    },
    handleView(file) {
      this.selectFile = file;
      this.showImage = true;
    },
    uploadFileError(file) {
      //文件上传失败处理
      this.$Message.warning(`${file.name}文件上传失败`);
    },
    fileMaxSize(file) {
      //文件上传大过5mb处理
      this.$Message.warning(`${file.name}文件，超出文件限制`);
    },
    upload() {
      let operation = null;
      let formData = new FormData();
      if (this.deleteFiles.length && this.value.id != null) {
        formData.append("deleteFilesJSON", JSON.stringify(this.deleteFiles));
        formData.append("uploadId", this.value.id);
        operation = "put";
      }
      if (this.model.files.length) {
        this.model.files.forEach((x) => {
          if (x.file) {
            formData.append("file", x.file);
            operation = "post";
          }
        });
      }
      if (operation == "post") {
        // 添加
        formData.append("UploadType", "Files");
        formData.append("businessType", this.config);
        return new Promise((resolve, reject) => {
          this.$axios({
            url: "/Upload",
            method: "POST",
            data: formData,
          }).then((res) => {
            resolve(res.data.uploads);
            // let files = res.data.uploads.files.map((x) => {
            //   return {
            //     no: x.o.no,
            //     name: x.o.name,
            //     path: x.o.path,
            //     fullPath: x.o.fullPath,
            //   };
            // });
            // resolve({
            //   filesCount: res.data.uploads.files.length,
            //   uploadId: res.data.uploads.id,
            //   files: files,
            // });
          });
        });
      } else if (operation == "put") {
        //删除
        return new Promise((resolve, reject) => {
          this.$axios({
            url: `/Upload/${this.value.id}`,
            method: "PUT",
            data: this.deleteFiles,
          }).then((res) => {
            if (res.data == null) {
              resolve(null);
              return;
            }
            if (res.data.uploads.files.length == null) {
              resolve(null);
              return;
            }
            resolve(res.data.uploads);
            // let files = res.data.uploads.files.map((x) => {
            //   return {
            //     no: x.o.no,
            //     name: x.o.name,
            //     path: x.o.path,
            //     fullPath: x.o.fullPath,
            //   };
            // });
            // resolve({
            //   filesCount: res.data.uploads.files.length,
            //   uploadId: res.data.uploads.id,
            //   files: files,
            // });
          });
        });
      } else {
        return new Promise((resolve) => {
          resolve(this.value);
        });
      }
    },
    beforeUpload(file) {
      if (file) {
        if (file.size > this.maxSize) {
          this.$Message.warning(
            `单个最大支持上传${this.maxSize / 1024 / 1024}M!`
          );
          return false;
        }
        if (this.model) {
          if (this.max != 0 && this.model.files.length >= this.max) {
            this.$Message.warning(`最大支持上传${this.max}个附件/图片!`);
            return false;
          }
          if (this.accept.indexOf("image") != -1) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              const base64 = reader.result;
              if (this.max != 0 && this.model.files.length >= this.max) {
                this.$Message.warning(`最大支持上传${this.max}个附件/图片!`);
                return false;
              }
              this.model.files.push({
                name: file.name,
                base64: base64,
                file: file,
              });
              // console.log(JSON.stringify(this.model))
            };
          } else {
            this.model.files.push({ name: file.name, file: file });
          }
        } //需要传给后台的file文件

        //
      }
      return false; //阻止图片继续上传，使得form表单提交时统一上传
    },
  },
};
</script>

<style>
.demo-upload-list {
  width: 100px;
  height: 135px;
  text-align: center;
  line-height: 135px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.demo-upload-list img {
  width: 100%;
  vertical-align: middle;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
</style>